<studio-dialog>
  <studio-dialog-title
    text="Warning: This will make your Digital Person inactive"
  ></studio-dialog-title>
  <studio-dialog-description
    text="Are you sure you want to undeploy &quot;{{ data.name }}&quot;?"
  ></studio-dialog-description>
  <studio-dialog-buttons-container>
    <studio-dialog-button
      theme="dark-secondary"
      text="Cancel"
      precedence="secondary"
      (click)="cancel()"
    ></studio-dialog-button>
    <studio-dialog-button
      text="Undeploy"
      precedence="primary"
      buttonTheme="error"
      (click)="confirm()"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
